module.exports = __webpack_public_path__ + "img/animation_src_1.c9d611b8.webp";